import React from 'react';
import { Form, Input } from 'antd';

/**
 * Reusable Text Input Field Component
 * Can be used across all modules (Staff, Customers, Transactions, etc.)
 * 
 * @param {string} name - Field name
 * @param {string} label - Field label
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether field is required
 * @param {boolean} readOnly - Whether field is read-only
 * @param {Array} rules - Additional validation rules
 * @param {string} type - Input type (text, password, etc.)
 * @param {number} maxLength - Maximum character length
 * @param {string} prefix - Input prefix (icon, text)
 * @param {string} suffix - Input suffix (icon, text)
 * @param {object} ...props - Additional props passed to Input component
 */
const TextField = ({ 
  name, 
  label, 
  placeholder, 
  required = false, 
  readOnly = false,
  rules = [],
  type = 'text',
  maxLength,
  prefix,
  suffix,
  ...props 
}) => (
  <Form.Item
    name={name}
    label={label}
    rules={required ? [{ required: true, message: `Please enter ${label.toLowerCase()}` }, ...rules] : rules}
  >
    <Input 
      type={type}
      placeholder={placeholder}
      size="large"
      maxLength={maxLength}
      prefix={prefix}
      suffix={suffix}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      readOnly={readOnly}
      style={readOnly ? { cursor: 'not-allowed', backgroundColor: '#f9fafb' } : { backgroundColor: '#f9fafb' }}
      {...props}
    />
  </Form.Item>
);

export default TextField;
